import { useAuth } from '@/context/AuthContext';
import { useState, useEffect } from "react";
import { Tooltip as ReactTooltip } from 'react-tooltip';

const NonComplianceItems = () => {
    const { apiFetch, user } = useAuth();
    const [actionItems, setActionItems] = useState([]);
    const [allProperties, setAllProperties] = useState([]);
    const [selectedTenant] = useState(null);

    // Fetch action items for this user
    const fetchActionItems = async () => {
        const response = await apiFetch(`/api/Ops/by-user/${user.userID}`);
        const data = await response.json();
        if (data.success && data.data) {
            setActionItems(data.data);
        }
    };

    // Fetch all properties for property name lookup
    const fetchAllProperties = async () => {
        const response = await apiFetch('/api/Property/all');
        const data = await response.json();
        if (data.success && data.data) {
            setAllProperties(data.data);
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            fetchActionItems();
            fetchAllProperties();
        }, 0);
        return () => clearTimeout(timer);
    }, [user.userID]);

    // Lookup maps
    const propertyIdToName = {};
    allProperties.forEach(p => {
        propertyIdToName[p.propertyID] = p.propertyName;
    });

    function formatDateToYMD(dateString) {
        if (!dateString) return "";
        // Handles both with and without time part
        const date = new Date(dateString);
        if (isNaN(date)) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() is zero-based
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    return (
        <div style={{ margin: "0 auto" }}>
            <h2>Action Items</h2>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Property</th>
                        <th>User</th>
                        <th>Tenant</th>
                        <th>Non-Compliance</th>
                        <th>Comments</th>
                        <th>Date Created</th>
                        <th>Created By</th>
                        <th>View Tenant Info</th>
                    </tr>
                </thead>
                <tbody>
                    {actionItems.map(item => (
                        <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{propertyIdToName[item.propertyID] || item.propertyID}</td>
                            <td>{user.firstName} {user.lastName}</td>
                            <td>{item.tenant || "-"}</td>
                            <td>{item.nonCompliance}</td>
                            <td>{item.comments || "-"}</td>
                            <td>{formatDateToYMD(item.createdDate)}</td>
                            <td>{user.firstName} {user.lastName}</td>
                            <td>
                                <span
                                    data-tooltip-id={`tenant-tooltip-${item.id}`}
                                    style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
                                >
                                    View Tenant Info
                                </span>
                                <ReactTooltip
                                    id={`tenant-tooltip-${item.id}`}
                                    place="right"
                                    effect="solid"
                                    clickable={true}
                                    style={{ whiteSpace: "pre-line" }}
                                >
                                    <div style={{ minWidth: 220 }}>
                                        <div style={{ fontWeight: "bold", paddingBottom: 2, fontSize: "1.2em", textAlign: "left", paddingLeft: "2px", background: "#f63040", color: "white" }}>
                                            {item.tenant || "Tenant"}
                                        </div>
                                        <table style={{ width: "100%", fontSize: "0.98em", borderCollapse: "collapse" }}>
                                            <tbody>
                                                <tr style={{ fontSize: "1.2em"  }}>
                                                    <td style={{ fontWeight: "bold", paddingRight: 8, verticalAlign: "top" }}>Response:</td>
                                                    <td>{item.tenantResponse || "-"}</td>
                                                </tr>
                                                <tr style={{ fontSize: "1.2em" }}>
                                                    <td style={{ fontWeight: "bold", paddingRight: 8, verticalAlign: "top" }}>Contact Name:</td>
                                                    <td>{item.tenantContactName || "-"}</td>
                                                </tr>
                                                <tr style={{ fontSize: "1.2em" }}>
                                                    <td style={{ fontWeight: "bold", paddingRight: 8, verticalAlign: "top" }}>Contact Number:</td>
                                                    <td>{item.tenantContactNumber || "-"}</td>
                                                </tr>
                                                <tr style={{ fontSize: "1.2em" }}>
                                                    <td style={{ fontWeight: "bold", paddingRight: 8, verticalAlign: "top" }}>Contact Email:</td>
                                                    <td>{item.tenantContactEmail || "-"}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </ReactTooltip>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {/* Modal or section for tenant info */}
            {selectedTenant && (
                <div>
                    {/* Fetch and display tenant info here */}
                    Tenant Info for ID: {selectedTenant}
                </div>
            )}
        </div>
    );
};

export default NonComplianceItems;